import { useQuery } from '@tanstack/react-query';
import { fetchArchivedJobs } from '../api/jobsApi.js';

// Deleted projects (archived to MongoDB on delete). Only fetched when `enabled`
// (i.e. the "Deleted" tab is active) so the archive isn't loaded on every visit.
export function useArchivedJobs(enabled = true) {
  return useQuery({
    queryKey: ['jobs', 'archived'],
    queryFn: fetchArchivedJobs,
    enabled,
    staleTime: 30000
  });
}
